var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreCrystalXs = function SvgStoreCrystalXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m3.728 2.908 2.194-.075L8.33 2.75l2.409-.082 2.194-.075 2.415 3.248-6.629 8.332-7.18-7.862z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#store-crystal-xs_svg__a)",
    stroke: "#000",
    d: "m12.933 2.594-2.194.075-2.409.082.39 11.423 6.628-8.332z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m15.315 5.825-6.874.19M8.72 14.174l3.174-8.277-1.155-3.228"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#store-crystal-xs_svg__b)",
    stroke: "#000",
    d: "m3.728 2.908 2.194-.075L8.33 2.75l.39 11.423-7.18-7.862z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m1.564 6.296 6.877-.282M8.72 14.175 4.99 6.132l.931-3.299"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.38 6.86c.028-.16.163-.8.761-1.267a2.13 2.13 0 0 1 1.544-.423 2.23 2.23 0 0 1-1.257-.823 2.23 2.23 0 0 1-.431-1.483c-.016.123-.123.865-.807 1.355a2.02 2.02 0 0 1-1.499.335c.212.076.803.318 1.239.947.391.564.442 1.129.451 1.36zM6.583 7.716c.015-.08.082-.399.38-.633.332-.26.702-.22.772-.211-.086-.02-.4-.105-.629-.412a1.12 1.12 0 0 1-.216-.74c-.008.06-.062.432-.404.676-.331.238-.687.18-.75.168.106.038.402.159.62.473.195.282.22.565.225.68z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "store-crystal-xs_svg__a",
    x1: 15.704,
    x2: 2.142,
    y1: 4.43,
    y2: 7.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A94F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "store-crystal-xs_svg__b",
    x1: 11.163,
    x2: -3.094,
    y1: 4.485,
    y2: 9.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A94F5"
  })))));
};
export default SvgStoreCrystalXs;